/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const downloadTransactionsStatementPostRequestSchema = z.object({
  file_type: z.string(),
  lower_date: z.string(),
  reference: z.string(),
  upper_date: z.string(),
});
